// extracted by mini-css-extract-plugin
export var carouselRoot = "TestimonioCarousel-module--carousel-root--+v1ah";
export var itemsContainer = "TestimonioCarousel-module--items-container--EMOZH";